import { createContext } from "react";

export const ArticulosTallesContext = createContext()
export const ArticulosTallesFormContext = createContext()
export const ArticulosTallesReportContext = createContext()